import type { RSUAsset, ShareAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateRSUPartInPortfolio, calculateStocksPartInPortfolio } from "./partInPortfolio";

export const calculateStocksExpectedYield = (
  userProduct: ShareAsset,
  cashCurrency: Fiat,
  baseCurrency: Fiat
) => {
  const stocks = userProduct?.stocksData || [];
  const partsInPortfolio = calculateStocksPartInPortfolio(
    userProduct,
    cashCurrency,
    baseCurrency
  );

  return stocks.reduce((sum, current, index) => {
    const expectedYield = current?.predictedValueIncrease || 0;
    const partInPortfolio = partsInPortfolio?.[index] || 0;

    return sum + expectedYield * partInPortfolio;
  }, 0);
};



export const calculateRSUsExpectedYield = (
  userProduct: RSUAsset,
  cashCurrency: Fiat,
  baseCurrency: Fiat
) => {
  const stocks = userProduct?.rsuData || [];
  const partsInPortfolio = calculateRSUPartInPortfolio(
    userProduct,
    cashCurrency,
    baseCurrency
  );

  return stocks.reduce((sum, current, index) => {
    const expectedYield = current?.predictedValueIncrease || 0;
    const partInPortfolio = partsInPortfolio?.[index] || 0;

    return sum + expectedYield * partInPortfolio;
  }, 0);
};
